import type { Distance, Point } from "@pdfking/math"
import { GetXY, RemoveMargins } from "@pdfking/math"

import type { Drawable } from "#internal"

import { SECURITY_COLOR_ID } from "../../../data/ColorList"
import { CreatePath } from "../../../shapes/CreatePath"

/** One security line per edge the fill keeps clear, that far inside its box. */
export const DrawFillHelp: Drawable = function* (node, frame) {
  const security = node.data?.fill?.security
  if (!security) return
  if (!(security.top || security.right || security.bottom || security.left)) return

  const { x1, x2, y1, y2 } = GetXY(frame.outer)
  const inner = GetXY(RemoveMargins(frame.outer, security))
  const across = (y: number) =>
    CreatePath(
      [
        { x: x1, y },
        { x: x2, y },
      ] as Point<Distance>[],
      SECURITY_COLOR_ID
    )
  const along = (x: number) =>
    CreatePath(
      [
        { x, y: y1 },
        { x, y: y2 },
      ] as Point<Distance>[],
      SECURITY_COLOR_ID
    )
  yield across(inner.y1)
  yield across(inner.y2)
  yield along(inner.x1)
  yield along(inner.x2)
}
